/*
	Create by BaiZhiMing 2015-1-10
*/
"use strict";
angular.module("inputPasswordModule", [])
    .controller("inputPasswordCtrl", ["$scope","$modalInstance","modalDialog", function($scope,$modalInstance,modalDialog) {
        $scope.confirm = function() {
        	if($scope.password===""||!angular.isDefined($scope.password)){
        		modalDialog.alertType("请输入密码","","warning",false);
        	}else{
        		$modalInstance.close($scope.password);
        	}
        };
        $scope.cancel = function(){
        	$modalInstance.dismiss();
        };
    }]);
